module.exports = __webpack_public_path__ + "static/media/travelbydenise.a8382899.png";